import React from "react";

import styles from "./DataCollector.module.scss";
import russian from "./russian.svg";
import {
  BaseDataCollectorProps,
  DataCollectorDate,
  DataCollectorEmail,
  DataCollectorMessage,
  DataCollectorRegular,
  DataCollectorSelect,
  DataCollectorTel,
} from "./DataCollectorProps";

type DataCollectorProps = (
  | DataCollectorRegular
  | DataCollectorTel
  | DataCollectorDate
  | DataCollectorSelect
  | DataCollectorEmail
  | DataCollectorMessage
) &
  BaseDataCollectorProps;

const DataCollector: React.FC<DataCollectorProps> = (props) => {
  const mode = props.mode;

  const [selectedItem, setSelectedItem] = React.useState("-");
  const [isSelectActive, setIsSelectActive] = React.useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (props.onChange) {
      props.onChange(e.target.value);
    }
  };
  const handleSelectChange = (value: string) => {
    setSelectedItem(value);
    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <div className={styles.field}>
      <h3 className={styles.title}>{props.title}</h3>
      {mode === "regular" && (
        <input
          type="text"
          className={`${styles.input} ${styles.regular}`}
          placeholder={props.placeholder}
          onChange={handleChange}
          value={props.value || ""}
        />
      )}
      {mode === "tel" && (
        <div className={styles.box}>
          <img src={russian} alt="russian" />
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path
              d="M5 8.28L10 13.28L15 8.28"
              stroke="#9D9595"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <input
            type="tel"
            className={`${styles.input} ${styles.regular}`}
            placeholder={props.placeholder}
            onChange={handleChange}
            value={props.value || ""}
          />
        </div>
      )}
      {mode === "date" && <input type="date" className={styles.input} />}
      {mode === "select" && (
        <div className={styles.select} onClick={() => setIsSelectActive(!isSelectActive)}>
          <h4 className={styles.selectTitle}>{selectedItem}</h4>
          <ul className={isSelectActive ? `${styles.selectList} ${styles.active}` : styles.selectList}>
            {props.itemList.map((item) => (
              <li
                onClick={() => {
                  setSelectedItem(item.text);
                  handleSelectChange(item.text);
                }}
                key={item.id}
                className={styles.selectItem}
              >
                {item.text}
              </li>
            ))}
          </ul>
          <div className={styles.arrow} />
        </div>
      )}
      {mode === "email" && (
        <input
          type="email"
          className={styles.input}
          placeholder={props.placeholder}
          onChange={handleChange}
          value={props.value || ""}
        />
      )}
      {mode === "message" && (
        <textarea
          className={`${styles.input} ${styles.message}`}
          placeholder={props.placeholder}
          onChange={handleChange}
          value={props.value || ""}
        />
      )}
    </div>
  );
};

export default DataCollector;
